import React, { useState } from 'react';
import { TrendingUp } from 'lucide-react';
import { InputGroup, InfoBox } from '../Common';

const PFTool = () => {
    const [tp, setTp] = useState(300000);
    const [tl, setTl] = useState(200000);

    const pf = tl === 0 ? 999 : (tp / tl);
    const status = pf < 1 ? "Losing" : pf < 1.3 ? "Weak" : pf < 2 ? "Good" : "Strong";
    const sClass = pf < 1 ? "val-red" : pf < 1.3 ? "val-amber" : pf < 2 ? "val-blue" : "val-green";

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Profit Factor Calculator</div>
            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Total Profit (₹)" value={tp} onChange={setTp} />
                <InputGroup label="Total Loss (₹)" value={tl} onChange={setTl} />
            </div>
            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-purple">
                    <div className="tct-data-row"><span className="tct-label">Profit Factor</span><span className="tct-value big-value">{pf.toFixed(2)}</span></div>
                    <div className="tct-data-row"><span className="tct-label">System Status</span><span className={`tct-value big-value ${sClass}`} style={{ textTransform: 'uppercase' }}>{status}</span></div>
                </div>
            </div>
            <InfoBox
                title="Profit Factor in Trading"
                meta="The Most Important Strategy Metric"
                sections={[
                    { title: "Introduction", content: "Profit factor measures how much profit a strategy generates relative to its losses.<br><br>It is one of the most widely used metrics in systematic trading." },
                    { title: "Formula", type: "formula", content: "Profit Factor = Gross Profit / Gross Loss" },
                    { title: "Example", content: "Total profit from winning trades = ₹300000<br>Total loss from losing trades = ₹200000<br><br>Profit Factor = 1.5<br><br>This means the strategy makes ₹1.5 for every ₹1 lost." },
                    { title: "Interpretation", content: "Profit factor less than 1 indicates a losing strategy.<br><br>Professional traders usually prefer:<br>Profit factor above 1.3." }
                ]}
            />
        </div>
    );
};

export default PFTool;
